/*
 * -----------------------------------------------------------------------
 *  <copyright file="admin-study-plugin.tsx" company="Triumph Research Intelligence">
 *      Copyright (C) 2019 by Triumph Research Intelligence. All rights reserved.
 *  </copyright>
 * -----------------------------------------------------------------------
 */

import { useLazyQuery } from '@apollo/client/react';
import React, { useEffect } from 'react';
import { useLocalState } from 'hooks';
import { GET_STUDY } from 'queries/studies';
import AdminPlugin from 'views/components/admin/admin-plugin';
import Loading from 'views/components/core/loading';
import Error from 'views/components/error/error';

const AdminStudyPlugin = () => {
    const { state } = useLocalState();
    const [loadStudy, { loading, error, data }] = useLazyQuery(GET_STUDY);

    useEffect(() => {
        if (state?.selectedStudy) loadStudy({ variables: { id: state?.selectedStudy.id } });
    }, [state.selectedStudy]);

    if (error) return <Error error={error} />;

    if (loading || !data) return <Loading />;

    return <AdminPlugin study={data.study} />;
};

export default AdminStudyPlugin;
